import React, { useState, useEffect } from 'react';
import {Helmet} from "react-helmet";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { Mail, Linkedin, Instagram } from "lucide-react";

import sope from "../../assets/bio.jpg"


const Bio = () => {

  // const [honorsData, setHonorsData] = useState([])
  const [soloExhibitions, setSoloExhibitions] = useState([])
  const [publicationsData, setPublicationsData] = useState([])
  const [content, setContent] = useState("");
  const [formData, setFormData] = useState({ fullName: '', email: '', message: '' });


  // Fetch abouttext when component mounts
  const fetchAboutText = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/abouttext`);

      if (response.ok) {
        const data = await response.json();
        console.log("Fetched Content:", data);

        // Ensure we get the correct content format
        if (data.about && data.about.content) {
          setContent(data.about.content);
        } else {
          console.error("No content available");
        }
      } else {
        console.error("Error fetching about text:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching about text:", error);
    }
  };


  // EXHIBITIONS (solo & group)
  const fetchExhibitions = async (category, setter) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/about-exhibitions?category=${category}`);
        if (response.ok) {
          const data = await response.json();
          setter(data);
        } else {
          console.error('Error fetching data');
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
  };

  // PUBLICATIONS
  const fetchPublicationsData = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/publications`);
        if (response.ok) {
          const data = await response.json();
          setPublicationsData(data);
        } else {
          console.error('Error fetching data');
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
  };


  useEffect(() => {
    // Fetch data from the backend
    fetchExhibitions('solo', setSoloExhibitions);
    fetchPublicationsData();
    fetchAboutText();
  }, []);


  // CONTACT FORM
  const contactForm = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      if (response.ok) {
        alert('Form submitted successfully');
        setFormData({ fullName: '', email: '', message: '' });
      } else {
        console.error('Form submission failed');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };


	return (
		<>
			<Helmet>
		        <title>Sope Adelaja | Photographer - Film Director</title>
		        <meta name="description" content="photographer, photography, portrait, commercial photographer" />
		    </Helmet>

			<div className="grid md:grid-cols-2 grid-cols-1 xl:px-[15em] lg:px-10 md:px-10 px-4 py-10 bg-[#252525] gap-8">
				<div className="py-4 mb-6 order-2 md:order-1">
					<div className="border-b border-[#484540] py-4 mb-6">
						<p
							className="uppercase text-xl text-[#e7ddd3] font-semibold tracking-[.15em]"
						>
							bio
						</p>
					</div>
					<div>
            <div className="no-select">
              <ReactQuill
                className="text-[#b7a78b] text-[15px] custom-quill p-4"
                value={content}
                readOnly={true} // Makes it non-editable
                theme="bubble" // Uses a minimal theme for display
              />
            </div>

            {/* CV button — links to the full CV page */}
            <div className="mt-6 px-4">
              <a
                href="/cv"
                className="inline-block bg-[#b7a78b] hover:bg-[#d0c3a6] text-[#252525] text-[13px] font-semibold uppercase tracking-[.15em] px-8 py-3 rounded transition-colors duration-300"
              >
                CV
              </a>
            </div>
					</div>
				</div>
				<div className="flex items-center justify-center order-1 md:order-2">
					<img
						src={sope}
						alt="Sope Adelaja"
						className="rounded-full w-[20em] md:w-60 lg:w-[30em] max-w-full aspect-square object-cover shrink-0"
					/>
				</div>
			</div>


			<div className="flex flex-col xl:flex-row xl:px-[15em] lg:px-10 md:px-10 px-4 py-10 bg-[#252525] gap-8">

  {/* Left Column (Exhibitions) */}
  <div className="flex flex-col flex-1 gap-8 order-1 xl:order-1">


    {/* Solo Exhibitions Section */}
    {soloExhibitions.length > 0 && (
    <div>
      <div className="border-b border-[#484540] py-4 mb-2">
        <h2 className="uppercase text-[#e7ddd3] text-xl font-semibold tracking-[.15em]">
          exhibitions
        </h2>
      </div>
      <ul className="list-disc pl-5 space-y-2 marker:text-[#b7a78b] mt-3">
        {soloExhibitions.map((exhibition) => (
        <li className="text-[#b7a78b] text-[15px] pl-1" key={exhibition._id}>
          {exhibition.year && <span className="text-[#b7a78b] mr-2">{exhibition.year}</span>}
          {exhibition.exhibitionName}
          {exhibition.exhibitionLink && (
            <a
              href={exhibition.exhibitionLink}
              target="_blank"
              rel="noreferrer"
              className="text-[#efefcb] underline decoration-current capitalize ml-2"
            >
              link
            </a>
          )}
        </li>
        ))}
      </ul>
    </div>
    )}

  </div>

  {/* Right Column (Publications) */}
  <div className="flex flex-col w-full lg:w-[300px] mx-auto bg-[#252525] gap-4 order-2 xl:order-2">
    <div className="border-b border-[#484540] py-4 mb-2">
      <h2
        className="uppercase text-[#e7ddd3] text-xl font-semibold tracking-[.15em]"
      >
        publications
      </h2>
    </div>
    {publicationsData.length > 0 && publicationsData.map((publications, index) => (
    <div className="" key={publications._id || index}>
      {/* Publication Entries */}
      <p className="text-[#b7a78b] text-[15px]">
        {publications.publicationName}
        {publications.publicationNames && <i> {publications.publicationNames}</i>}
        {publications.publicationLink && (
          <a
            href={publications.publicationLink}
            target="_blank"
            rel="noreferrer"
            className="text-[#efefcb] underline decoration-current capitalize ml-2"
          >
            link
          </a>
        )}
      </p>
    </div>
    ))}
  </div>
</div>


			{/* Contact form */}
			<div className="bg-[#252525] px-4 xl:px-[15em] lg:px-10 md:px-10 pb-20">
				<div className="border-b border-[#484540] py-4 mb-6">
					<h2 className="uppercase text-[#e7ddd3] text-xl font-semibold tracking-[.15em]">contact</h2>
				</div>

				<p className="text-[#b7a78b] text-[15px] mb-8">Please use the form below to get in contact with me directly.</p>

				<form className="space-y-6" onSubmit={contactForm}>
					<div className="grid xl:grid-cols-2 lg:grid-cols-2 grid-cols-1 gap-6 items-stretch">
						<div className="flex flex-col gap-6">
							<input
								type="text"
								placeholder="Name"
								name="fullName"
								value={formData.fullName}
								onChange={handleInputChange}
								required
								className="w-full bg-transparent border border-[#484540] rounded px-4 py-3 text-[14px] text-[#e7ddd3] placeholder-[#8a8175] focus:outline-none focus:border-[#b7a78b] transition-colors"
							/>
							<input
								type="email"
								placeholder="Email"
								name="email"
								value={formData.email}
								onChange={handleInputChange}
								pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}"
								required
								className="w-full bg-transparent border border-[#484540] rounded px-4 py-3 text-[14px] text-[#e7ddd3] placeholder-[#8a8175] focus:outline-none focus:border-[#b7a78b] transition-colors"
							/>
						</div>
						<div>
							<textarea
								placeholder="Message"
								rows="6"
								name="message"
								value={formData.message}
								onChange={handleInputChange}
								required
								className="w-full h-full min-h-[140px] bg-transparent border border-[#484540] rounded px-4 py-3 text-[14px] text-[#e7ddd3] placeholder-[#8a8175] focus:outline-none focus:border-[#b7a78b] transition-colors resize-none"
							></textarea>
						</div>
					</div>

					<div className="flex justify-end">
						<button className="w-[200px] border border-[#b7a78b] text-[#b7a78b] text-[11px] font-medium py-4 uppercase tracking-[0.2em] hover:bg-[#b7a78b] hover:text-[#252525] transition-colors duration-300">
							Send Message
						</button>
					</div>
				</form>
			</div>

			{/* Social links — centered under the contact form */}
			<div className="bg-[#252525] px-4 pb-16">
				<div className="flex items-center justify-center gap-6">
					<a href="mailto:hello@sopeadelaja.com" aria-label="Email" className="flex items-center justify-center w-12 h-12 rounded-full border border-[#b7a78b] text-[#b7a78b] hover:bg-[#b7a78b] hover:text-[#252525] transition-colors duration-300">
						<Mail className="w-5 h-5" />
					</a>
					<a href="https://linkedin.com/in/sope-adelaja/" target="_blank" rel="noreferrer" aria-label="LinkedIn" className="flex items-center justify-center w-12 h-12 rounded-full border border-[#b7a78b] text-[#b7a78b] hover:bg-[#b7a78b] hover:text-[#252525] transition-colors duration-300">
						<Linkedin className="w-5 h-5" />
					</a>
					<a href="https://instagram.com/sopeadelaja" target="_blank" rel="noreferrer" aria-label="Instagram" className="flex items-center justify-center w-12 h-12 rounded-full border border-[#b7a78b] text-[#b7a78b] hover:bg-[#b7a78b] hover:text-[#252525] transition-colors duration-300">
						<Instagram className="w-5 h-5" />
					</a>
				</div>
			</div>


		</>
	)
}

export default Bio
